import { render, staticRenderFns } from "./EventRegistration.vue?vue&type=template&id=20d8d3b4&scoped=true&"
import script from "./EventRegistration.vue?vue&type=script&lang=js&"
export * from "./EventRegistration.vue?vue&type=script&lang=js&"
import style0 from "./EventRegistration.vue?vue&type=style&index=0&id=20d8d3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8d3b4",
  null
  
)

export default component.exports